jQuery(document).ready(function ($) {

  // helpful services
  enquire.register("screen and (max-width: 767px)", function () {
    $('.highlighted-links .slides').cycle({
      speed: 350,
      manualSpeed: 350,
      timeout: 0,
      pager: '.hl-pager',
      pagerTemplate: '<span tab-index="0" aria-label="Change Slide"></span>',
      prev: '.hs-prev',
      next: '.hs-next',
      easing: 'linear',
      fx: 'carousel',
      carouselVisible: 1,
      carouselFluid: true,
      slides: '.slide',
      allowWrap: true,
      swipe: true,
      swipefx: 'scrollHorz'
    });

  }).register("screen and (min-width: 768px) and (max-width: 1025px)", function () {
    $('.highlighted-links .slides').cycle({
      speed: 350,
      manualSpeed: 350,
      timeout: 0,
      pager: '.hl-pager',
      pagerTemplate: '<span tab-index="0" aria-label="Change Slide"></span>',
      prev: '.hs-prev',
      next: '.hs-next',
      easing: 'linear',
      fx: 'carousel',
      carouselVisible: 2,
      carouselFluid: true,
      slides: '.slide',
      allowWrap: true,
      swipe: true,
      swipefx: 'scrollHorz'
    });
  }).register("screen and (min-width: 1025px)", function () {
    $('.highlighted-links .slides').cycle('destroy');
  });

    //Fade in on scroll
    $.fn.isInViewport = function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };
  
    $('a[data-anchorlink="true"]').on('click', function (e) {
      e.preventDefault();
      var aID = $(this).attr('href');
      document.getElementById(aID).scrollIntoView({
        behavior: 'smooth'
      });
    });
  
    $(window).on('resize scroll', function () {
      $('.homepage main > *, .homepage main > div, .homepage main > section').each(function () {
        if ($(this).isInViewport()) {
          $(this).animate({ 'opacity': '1' }, 2000);
        }
      });
    });
  
    //If already in view, don't fade in
    $(window).on('load', function () {
      $('.homepage main > *, .homepage main > div, .homepage main > section').each(function () {
        if ($(this).isInViewport()) {
          $(this).animate({ 'opacity': '1' }, 500);
        }
      });
    });

    $(window).on("scroll", function () {
      $('.highlighted-links').each(function () {
        if ($(this).isInViewport()) {
          $('.slide').each(function () {
            $(".slide:first-child").addClass("fade-in");
            setTimeout(function () {
              $(".slide:nth-child(2)").addClass("fade-in");
            }, 500);
            setTimeout(function () {
              $(".slide:nth-child(3)").addClass("fade-in");
            }, 1000);
            setTimeout(function () {
              $(".slide:nth-child(4)").addClass("fade-in");
            }, 1500);
          });
        }
      });
    });

  enquire.register("screen and (min-width: 1025px)", function () {
    textify = function(method,delay) {
      $(".hp-slideshow .slide .title").each(function () {
        words = $(this).text().split("");
        for (var i in words) {
          words[i] = "<span>" + words[i] + "</span>";
        }
        text = words.join("");
        $(this).html(text);
      });      
      $('.hp-slideshow .slide .title' + ' span').css('opacity','0');
      $('.hp-slideshow .slide .title' + ' span').css('position','relative');

      in_speed = 10;
      count = 0;
      setTimeout(function(){
        count = 0;
        $('.hp-slideshow .cycle-slide-active .title' + ' span').each(function () {
          if(method == 'bounce'){
            $(this).delay(0 + in_speed * count).animate({ opacity: '1','top':'-4px'}, 220);
            $(this).delay(0 + in_speed * count/4).animate({ opacity: '1','top':'0px'}, 220);
          }
          count++;
        });
      },delay);
    };
    
    // /* Now textify! */
    // First Slide
    textify('bounce',500);

    // Then the rest
    $( '.cycle-slideshow.hp-slideshow' ).on('cycle-before', function( event, opts, prev, next) {
      textify('bounce',500);
    });
  });

});

$(".slide.hide").remove();
